// extracted by mini-css-extract-plugin
export default {"wrapper":"questions_wrapper__bwTXk","title":"questions_title__7YYiT"};